import CommonDialog from '../../shared/dialog/CommonDialog';
import css from '../account-settings.module.scss';
import { AddDeviceForm } from './AddDeviceForm';

interface AddDeviceDialogProps {
  shouldShow: boolean;
  handleClose: () => void;
  successCallback: () => void;
}

export default function AddDeviceDialog({
  shouldShow,
  handleClose,
  successCallback,
}: AddDeviceDialogProps) {
  return (
    <CommonDialog
      data-testid="addDeviceDialog"
      dialogOpen={shouldShow}
      handleDialogClose={handleClose}
      classNames={{
        body: css.dialogBody,
        content: css.dialogContent,
      }}
      closeButtonProps={{ className: css.closeIcon }}
      preventOverlayClose
    >
      <AddDeviceForm successCallback={successCallback} />
    </CommonDialog>
  );
}
